import styled, { css } from 'styled-components'
import { hiloImg } from './gameAssets'

const designerCSS = css`
  .content {
    position: relative;
    height: calc(100% + 15px);
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0 0 0 0;
    overflow: hidden;
  }

  div.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      circle at 50% 50%,
      hsla(210, 19%, 16%, 0.6),
      hsla(214, 19%, 15%, 0.6),
      hsla(210, 18%, 13%, 0.6),
      hsla(213, 19%, 12%, 0.6),
      hsla(216, 19%, 10%, 0.6),
      hsla(210, 18%, 9%, 0.6),
      hsla(214, 19%, 7%, 0.7),
      hsla(204, 17%, 6%, 0.7),
      hsla(210, 18%, 4%, 0.7),
      hsla(220, 20%, 3%, 0.8),
      hsla(180, 14%, 1%, 0.8),
      hsla(0, 0%, 0%, 0.9)
    );
    backdrop-filter: blur(10px);
    z-index: 2;
  }

  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .games_panel details .content {
    position: relative;
    z-index: 0;
    height: auto;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    transition: all 1s;
  }
  .content section {
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    width: 100%;
    padding: 15px 0;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  .content section .row {
    flex-flow: row;
    justify-content: space-between;
    margin: 0;
    padding: 0 15px;
    display: flex;
    align-items: center;
  }
  details .content button {
    width: 100%;
    text-align: center;
    font-size: 0.8rem;
    text-transform: uppercase;
    padding: 15px 0;
    line-height: 100%;
    font-weight: 500;
  }
  .togCheck:checked + .togContent details.yolo_hilo .content {
    padding: 0;
  }
  section.hilo_wrapper {
    background: url(${hiloImg.table_felt_bg}) center center / 200% auto no-repeat;
    width: 100%;
    display: flex;
    justify-content: center;
    border: 0;
    padding: 0;
  }
  section.hilo_wrapper .row.main {
    justify-content: center;
    align-items: center;
    height: 240px;
    flex-direction: row;
    position: relative;
  }
  section.hilo_wrapper .row.status {
    background: hsla(142, 76%, 9%, 0.5);
    background: hsla(221, 73%, 47%, 0.4);
    background: hsla(126, 100%, 38%, 0.2);
    padding: 8px 15px;
    font-size: 0.8rem;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  section.hilo_wrapper .row.status button.stats_button {
    font-size: 0.7rem;
    background: hsla(0, 0%, 0%, 0.3);
    border-radius: 5px;
    padding: 5px 8px;
    width: fit-content;
    text-transform: none;
  }
  section.hilo_wrapper .row.status .status_message {
    position: relative;
  }
  section.hilo_wrapper .row.status .status_message div {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.85rem;
    font-weight: 600;
  }
  section.hilo_wrapper .row.status .payout_amount {
    font-size: 1.5rem;
    font-weight: 600;
    letter-spacing: -0.02em;
  }
  section.hilo_wrapper .row.status .payout_amount.won {
    color: var(--site-result-won-color);
  }
  section.hilo_wrapper .row.status .payout_amount.loss {
    color: var(--site-result-lost-color);
  }
  section.hilo_wrapper .row.status .payout_amount.neutral {
    color: var(--site-result-unknown-color);
  }
  section.hilo_wrapper .cards_wrap {
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 240px;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  section.hilo_wrapper .cards_wrap .display_stats {
    position: absolute;
    bottom: 10px;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  section.hilo_wrapper .cards_wrap .display_stats:hover {
    cursor: pointer;
    bottom: 7px;
    font-size: 0.7rem;
    background: hsla(0, 0%, 0%, 0.3);
    border-radius: 5px;
    padding: 3px 5px;
    width: fit-content;
    text-transform: none;
  }

  section.hilo_wrapper .cards_wrap .display_stats .streak,
  section.hilo_wrapper .cards_wrap .display_stats .rank {
    font-size: 0.65rem;
    margin: 0 5px;
  }
  section.hilo_wrapper .cards_wrap .display_stats .streak span:first-child,
  section.hilo_wrapper .cards_wrap .display_stats .rank span:first-child {
    border-bottom: 1px dotted var(--link-underline-color);
  }
  section.hilo_wrapper .cards_wrap .display_stats .streak span:last-child,
  section.hilo_wrapper .cards_wrap .display_stats .rank span:last-child {
    background: hsla(0, 0%, 0%, 0.4);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: 800;
    margin: 0 0 0 5px;
  }
  section.hilo_wrapper .single_card {
    width: 100%;
    display: flex;
    position: absolute;
    transform: perspective(70em) rotateX(5deg);
  }
  section.hilo_wrapper .single_card.front {
    transform: translate(-50%, -50%);
    z-index: 3;
    box-shadow: 0 0 45px 0 hsla(0, 0%, 0%, 0.65);
    width: 107px;
    height: 150px;
  }
  section.hilo_wrapper .single_card.back {
    top: calc(50% - 40px);
    left: calc(50% - 38px);
    z-index: 2;
    width: 68px;
    height: 40%;
    transform: translate(-50%, -50%);
  }
  section.hilo_wrapper .direction_buttons {
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    display: flex;
    margin: 0 10px 0 0;
    position: absolute;
    right: 30px;
  }
  section.hilo_wrapper .bid_buttons {
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    display: flex;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    z-index: 1;
    width: 60px;
  }
  section.hilo_wrapper .bid_buttons .title {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0 0 5px 0;
  }
  section.hilo_wrapper .bid_buttons button.chip {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-position: center center;
    background-size: 40px auto;
    background-repeat: no-repeat;
    /* margin: 0 0 5px 0; */
  }
  section.hilo_wrapper .bid_buttons button.chip.two-dollars {
    background-image: url(${hiloImg.chip_2_dollars});
  }
  section.hilo_wrapper .bid_buttons button.chip.five-dollars {
    background-image: url(${hiloImg.chip_5_dollars});
  }
  section.hilo_wrapper .bid_buttons button.chip.twenty-dollars {
    background-image: url(${hiloImg.chip_20_dollars});
  }
  section.hilo_wrapper .bid_buttons button.chip.disabled {
    cursor: pointer !important;
    filter: brightness(70%) contrast(1.4);
  }
  section.hilo_wrapper .bid_buttons button.chip.selected {
    width: 60px;
    height: 60px;
    background-size: 60px auto;
    -webkit-box-shadow: 0 0 45px 0 hsla(0, 0%, 0%, 0.6);
    box-shadow: 0 0 45px 0 hsla(0, 0%, 0%, 0.6);
  }
  section.hilo_wrapper .direction_buttons button {
    padding: 8px 15px 7px 15px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  section.hilo_wrapper .direction_buttons button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  section.hilo_wrapper .direction_buttons fieldset {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  section.hilo_wrapper .direction_buttons fieldset .payout_value,
  section.hilo_wrapper .direction_buttons fieldset button .payout_value {
    font-size: 0.7rem;
    font-weight: 600;
  }
  section.hilo_wrapper .direction_buttons fieldset.hi button {
    background: url(${hiloImg.hi_button_bg}) center center / 45px auto no-repeat;
    width: 45px;
    height: 45px;
  }
  section.hilo_wrapper .direction_buttons fieldset.hi .payout_value {
    margin: 0 0 2px 0;
  }
  section.hilo_wrapper .direction_buttons fieldset.same button {
    background: url(${hiloImg.same_button_bg}) center center / 45px auto no-repeat;
    width: 45px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 0;
  }
  section.hilo_wrapper .direction_buttons fieldset.same button:hover {
    background-image: url(${hiloImg.same_button_bg_hover});
  }
  section.hilo_wrapper .direction_buttons fieldset.same button .payout_value {
    margin: 0;
  }
  section.hilo_wrapper .direction_buttons fieldset.lo button {
    background: url(${hiloImg.lo_button_bg}) center center / 45px auto no-repeat;
    width: 45px;
    height: 45px;
  }
  section.hilo_wrapper .direction_buttons fieldset.lo .payout_value {
    margin: 2px 0 0 0;
  }
  section.hilo_wrapper .direction_buttons fieldset.same button:hover .payout_value {
    display: none;
  }
  section.hilo_wrapper .direction_buttons fieldset button:hover {
    filter: invert(1);
  }
  section.hilo_wrapper .streak_list_wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 10px 0 0;
    display: none;
  }
  section.hilo_wrapper ul.streak_list {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 3px 10px 3px 0;
    max-height: 100px;
    overflow-y: auto;
    min-width: 80px;
  }
  section.hilo_wrapper ul.streak_list li {
    font-size: 0.75rem;
    padding: 5px 20px 6px 0;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 80px;
    height: 15px;
    display: inline-block;
    min-height: 15px;
  }
  section.hilo_wrapper .streak_title {
    font-weight: 600;
    padding: 0 0 5px 0;
    white-space: break-all;
    max-width: 50px;
    font-size: 0.7rem;
    text-transform: uppercase;
  }
  section.hilo_wrapper ul.streak_list li.rank1 {
    background: url('http://yolo.tino.me/app_v3/resources/images/icons/rank_1_icon.svg') right center / 14px auto
      no-repeat;
  }
  .togCheck:checked + .togContent details .content {
    visibility: visible;
    height: 100%;
    width: 100%;
    padding: 5px 0;
    opacity: 1;
  }
  .togCheck + .togContent details .content {
    visibility: hidden;
    height: 0;
    width: 0;
    opacity: 0;
  }
  section.hilo_wrapper .bid_buttons input.other_amount {
    position: relative;
    width: 60px;
    border-radius: 10px;
    padding: 5px 8px;
    margin: 10px 0 0 0;
    background: #032a14;
    font-size: 0.75rem;
    text-align: center;
    border: 1px solid hsla(0, 0%, 100%, 0.2);
  }
`

const maintenanceOverlayCSS = css`
  section.hilo_wrapper:before {
    z-index: 99;
    background: hsla(0, 0%, 0%, 0.4);
    backdrop-filter: blur(10px);
    width: calc(100% - 120px);
    height: 100%;
    content: 'HI-LO is down for maintenance. Please try again soon.';
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.9rem;
    padding: 60px;
    line-height: 130%;
  }
`
const developerCSS = css``

export const HiLoSideGameCSS = styled.div`
  width: 100%;
  ${designerCSS}
  /* ${maintenanceOverlayCSS} */
  ${developerCSS}
`
